import { combineReducers } from "redux";
import {
  TiReducer,
  AuthentificationReducer,
} from "../../modules/TI/state/TiReducer";
import { TitreReducer } from "../../modules/TI/state/TitreReducer";

const rootReducer = combineReducers({
  tiReducer: TiReducer,
  authentificationReducer: AuthentificationReducer,
  titreReducer: TitreReducer,
});

export default rootReducer;
